/* FLAIR - comportements du thème : en-tête, bannière, compte à rebours, panier, fiche produit, pop-up de grattage. */
(function () {
  'use strict';

  var cfg = window.FLAIR || { routes: {} };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };

  /* ---------- Hauteur du bandeau ---------- */
  function setHeights() {
    var a = $('[data-announce]');
    document.documentElement.style.setProperty('--announce-h', (a ? a.offsetHeight : 0) + 'px');
  }

  /* ---------- En-tête ---------- */
  function initHeader() {
    var h = $('[data-header]');
    if (!h || h.__init) return;
    h.__init = true;
    var overlay = h.classList.contains('header--can-overlay') && !!$('.hero[data-over="true"]');
    if (!overlay) { h.classList.add('is-solid'); return; }
    function upd() { h.classList.toggle('is-solid', window.scrollY > 8 || !!h.__hover || !!h.__menu); }
    window.addEventListener('scroll', upd, { passive: true });
    h.addEventListener('mouseenter', function () { h.__hover = true; upd(); });
    h.addEventListener('mouseleave', function () { h.__hover = false; upd(); });
    h.__upd = upd;
    upd();
  }

  function toggleMenu() {
    var m = $('[data-mobile-menu]');
    var h = $('[data-header]');
    if (!m) return;
    var open = m.hidden;
    m.hidden = !open;
    document.body.classList.toggle('no-scroll', open);
    $$('.header__burger').forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    if (h) { h.__menu = open; if (h.__upd) h.__upd(); }
  }

  /* ---------- Bannière ---------- */
  function initHero() {
    $$('[data-hero]').forEach(function (hero) {
      if (hero.__init) return;
      hero.__init = true;
      var slides = $$('[data-slide]', hero);
      var bars = $$('[data-bar]', hero);
      var auto = parseInt(hero.getAttribute('data-autoplay'), 10) || 0;
      var i = 0, t;
      hero.style.setProperty('--dur', (auto || 6) + 's');
      if (!auto) hero.classList.add('no-auto');

      function schedule() {
        clearTimeout(t);
        if (auto > 0 && slides.length > 1) t = setTimeout(function () { show(i + 1); }, auto * 1000);
      }
      function show(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
        bars.forEach(function (b, k) {
          b.classList.remove('is-active');
          if (k === i) { void b.offsetWidth; b.classList.add('is-active'); }
        });
        schedule();
      }
      bars.forEach(function (b, k) { b.addEventListener('click', function () { show(k); }); });
      if (slides.length) show(0);
    });
  }

  /* ---------- Compte à rebours ---------- */
  function initCountdown() {
    $$('[data-countdown]').forEach(function (el) {
      if (el.__init) return;
      el.__init = true;
      var end = new Date(String(el.getAttribute('data-countdown')).replace(' ', 'T')).getTime();
      var label = el.firstElementChild;
      var out = $('[data-cd]', el);
      if (isNaN(end)) { el.hidden = true; return; }
      var iv;
      function tick() {
        var d = end - Date.now();
        if (d <= 0) {
          label.textContent = el.getAttribute('data-label-end') || '';
          out.textContent = '';
          clearInterval(iv);
          return;
        }
        var s = Math.floor(d / 1000);
        out.textContent = Math.floor(s / 86400) + 'j ' + pad(Math.floor(s % 86400 / 3600)) + 'h ' + pad(Math.floor(s % 3600 / 60)) + 'm ' + pad(s % 60) + 's';
      }
      iv = setInterval(tick, 1000);
      tick();
    });
  }

  /* ---------- Panier ---------- */
  function drawer() { return $('[data-cart-drawer]'); }
  function openCart() {
    var d = drawer();
    if (!d) return;
    d.hidden = false;
    document.body.classList.add('no-scroll');
    requestAnimationFrame(function () { requestAnimationFrame(function () { d.classList.add('is-open'); }); });
  }
  function closeCart() {
    var d = drawer();
    if (!d || d.hidden) return;
    d.classList.remove('is-open');
    document.body.classList.remove('no-scroll');
    setTimeout(function () { d.hidden = true; }, 300);
  }
  function setCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n > 0 ? ' (' + n + ')' : ''; });
  }
  function refreshCart() {
    return fetch(cfg.routes.root + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var doc = new DOMParser().parseFromString(j['cart-drawer'], 'text/html');
        var fresh = $('[data-cart-drawer-inner]', doc);
        var cur = $('[data-cart-drawer-inner]');
        if (fresh && cur) {
          cur.innerHTML = fresh.innerHTML;
          cur.setAttribute('data-count', fresh.getAttribute('data-count'));
          setCount(parseInt(fresh.getAttribute('data-count'), 10) || 0);
        }
        var nh = $('.drawer__head span', doc), ch = $('.drawer__head span');
        if (nh && ch) ch.textContent = nh.textContent;
      });
  }
  function changeLine(line, qty) {
    fetch(cfg.routes.cart_change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function (r) { return r.json(); }).then(refreshCart);
  }

  /* ---------- Fiche produit ---------- */
  function initProduct() {
    var root = $('[data-product]');
    if (!root || root.__init) return;
    root.__init = true;
    var dataEl = $('[data-product-json]', root);
    var form = $('[data-product-form]', root);
    if (!dataEl || !form) return;
    var json = JSON.parse(dataEl.textContent);
    var idInput = $('[name="id"]', form);
    var priceEl = $('[data-price]', root);
    var btn = $('[data-add]', form);
    var fields = $$('[data-option]', root);

    function update() {
      var sel = fields.map(function (f) { var c = $('input:checked', f); return c ? c.value : null; });
      var v = json.variants.filter(function (x) {
        return sel.every(function (o, k) { return x.options[k] === o; });
      })[0];
      if (!v) {
        btn.disabled = true;
        btn.textContent = btn.getAttribute('data-label-sold');
        return;
      }
      idInput.value = v.id;
      btn.disabled = !v.available;
      btn.textContent = v.available ? btn.getAttribute('data-label-add') : btn.getAttribute('data-label-sold');
      priceEl.innerHTML = (v.onsale ? '<s>' + v.compare + '</s>' : '') + v.price;
      try {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', u.toString());
      } catch (e) {}
    }
    fields.forEach(function (f) { f.addEventListener('change', update); });
    update();
  }

  /* ---------- Pop-up de grattage ---------- */
  function initPopup() {
    var root = $('[data-popup]');
    if (!root || root.__init) return;
    root.__init = true;
    var confEl = $('#flair-popup-config');
    var conf;
    try { conf = JSON.parse(confEl.textContent); } catch (e) { return; }

    var params = new URLSearchParams(window.location.search);
    var force = params.get('popup');
    var autoOpen = true;
    if (!force) {
      if (!conf.enabled) autoOpen = false;
      else if (conf.onlyHome && cfg.template !== 'index') autoOpen = false;
      else if (cfg.designMode) autoOpen = !!conf.previewEditor;
      else {
        try {
          if (window.localStorage.getItem('flair_popup_done')) autoOpen = false;
          var ts = parseInt(window.localStorage.getItem('flair_popup_seen') || '0', 10);
          if (conf.repeatDays > 0 && ts && Date.now() - ts < conf.repeatDays * 864e5) autoOpen = false;
        } catch (e) {}
      }
    }

    var T = conf.t;
    var cv = $('[data-scratch]', root);
    var prize = $('[data-prize]', root);
    var prizeIn = $('[data-prize-in]', root);
    var form = $('form', root);
    var done = $('[data-popup-done]', root);
    var err = $('[data-popup-err]', root);
    var email = $('#popup-email', root);
    var consent = $('#popup-consent', root);
    var hint = $('[data-popup-hint]', root);
    var tagsInput = $('[data-popup-tags]', root);
    var submitBtn = $('[data-popup-submit]', root);
    var closeBtn = $('.popup__x', root);

    var ctx = null, dpr = 1, outcome = 'lose', revealed = false, touched = false, drawing = false;
    var last = null, lastCheck = 0, lastFocus = null;

    function setHead(c) {
      $('[data-popup-eyebrow]', root).textContent = c.eyebrow;
      $('[data-popup-title]', root).textContent = c.title;
      $('[data-popup-text]', root).textContent = c.text;
    }
    function fillPrize() {
      var c = T[outcome];
      prizeIn.className = 'prize__in ' + outcome;
      prizeIn.innerHTML = '';
      var k = document.createElement('span');
      k.className = 'prize__k';
      k.textContent = c.prizeTitle;
      var v = document.createElement('span');
      v.className = 'prize__v';
      v.textContent = c.prizeSub;
      prizeIn.appendChild(k);
      prizeIn.appendChild(v);
      if (outcome === 'win') {
        var d = document.createElement('span');
        d.className = 'prize__dash';
        prizeIn.appendChild(d);
        if (c.stub) {
          var st = document.createElement('span');
          st.className = 'prize__stub';
          st.textContent = c.stub;
          prizeIn.appendChild(st);
        }
      }
    }

    function rr(x, y, w, h, r) {
      ctx.beginPath();
      ctx.moveTo(x + r, y);
      ctx.arcTo(x + w, y, x + w, y + h, r);
      ctx.arcTo(x + w, y + h, x, y + h, r);
      ctx.arcTo(x, y + h, x, y, r);
      ctx.arcTo(x, y, x + w, y, r);
      ctx.closePath();
    }

    function paint() {
      var w = cv.width, h = cv.height;
      ctx.globalCompositeOperation = 'source-over';
      ctx.clearRect(0, 0, w, h);
      ctx.fillStyle = '#24120a';
      ctx.fillRect(0, 0, w, h);
      var cols = 4, rows = 3, gap = 5 * dpr, pd = 8 * dpr;
      var cw = (w - pd * 2 - gap * (cols - 1)) / cols;
      var ch = (h - pd * 2 - gap * (rows - 1)) / rows;
      var r, c, x, y, g;
      for (r = 0; r < rows; r++) {
        for (c = 0; c < cols; c++) {
          x = pd + c * (cw + gap);
          y = pd + r * (ch + gap);
          g = ctx.createLinearGradient(x, y, x + cw, y + ch);
          g.addColorStop(0, '#6a3d26');
          g.addColorStop(1, '#4a2816');
          ctx.fillStyle = g;
          rr(x, y, cw, ch, 4 * dpr);
          ctx.fill();
          ctx.lineWidth = 2 * dpr;
          ctx.strokeStyle = 'rgba(255,226,196,0.28)';
          ctx.beginPath();
          ctx.moveTo(x + 4 * dpr, y + ch - 4 * dpr);
          ctx.lineTo(x + 4 * dpr, y + 4 * dpr);
          ctx.lineTo(x + cw - 4 * dpr, y + 4 * dpr);
          ctx.stroke();
          ctx.strokeStyle = 'rgba(0,0,0,0.35)';
          ctx.beginPath();
          ctx.moveTo(x + cw - 4 * dpr, y + 4 * dpr);
          ctx.lineTo(x + cw - 4 * dpr, y + ch - 4 * dpr);
          ctx.lineTo(x + 4 * dpr, y + ch - 4 * dpr);
          ctx.stroke();
        }
      }
      var lw = Math.min(w * 0.6, 220 * dpr), lh = 36 * dpr;
      ctx.fillStyle = '#ffffff';
      ctx.fillRect((w - lw) / 2, (h - lh) / 2, lw, lh);
      ctx.fillStyle = '#000000';
      ctx.font = '500 ' + 14 * dpr + 'px ' + (getComputedStyle(document.body).fontFamily || 'Arial, sans-serif');
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(T.scratch, w / 2, h / 2 + 1 * dpr);
    }

    function setup() {
      var r = prize.getBoundingClientRect();
      dpr = Math.min(window.devicePixelRatio || 1, 2);
      cv.width = Math.max(1, Math.round(r.width * dpr));
      cv.height = Math.max(1, Math.round(r.height * dpr));
      ctx = cv.getContext('2d', { willReadFrequently: true });
      paint();
    }

    function pos(e) {
      var r = cv.getBoundingClientRect();
      return { x: (e.clientX - r.left) * cv.width / r.width, y: (e.clientY - r.top) * cv.height / r.height };
    }
    function scratch(a, b) {
      ctx.globalCompositeOperation = 'destination-out';
      ctx.lineWidth = 42 * dpr;
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
      ctx.beginPath();
      ctx.moveTo(a.x, a.y);
      ctx.lineTo(b.x, b.y);
      ctx.stroke();
      ctx.beginPath();
      ctx.arc(b.x, b.y, 21 * dpr, 0, Math.PI * 2);
      ctx.fill();
    }
    function check() {
      if (revealed || !ctx) return;
      var w = cv.width, h = cv.height, d = ctx.getImageData(0, 0, w, h).data, n = 0, t = 0, x, y;
      for (y = 0; y < h; y += 8) {
        for (x = 0; x < w; x += 8) {
          t++;
          if (d[(y * w + x) * 4 + 3] < 128) n++;
        }
      }
      if (n / t >= 0.5) reveal();
    }
    function reveal() {
      if (revealed) return;
      revealed = true;
      cv.style.opacity = '0';
      cv.style.pointerEvents = 'none';
      setTimeout(function () { cv.hidden = true; }, 520);
      hint.hidden = true;
      setHead(T[outcome]);
      submitBtn.textContent = T[outcome].cta;
      form.hidden = false;
    }

    cv.addEventListener('pointerdown', function (e) {
      if (revealed) return;
      drawing = true;
      touched = true;
      try { cv.setPointerCapture(e.pointerId); } catch (x) {}
      last = pos(e);
      scratch(last, last);
    });
    cv.addEventListener('pointermove', function (e) {
      if (!drawing) return;
      var p = pos(e);
      scratch(last, p);
      last = p;
      var now = Date.now();
      if (now - lastCheck > 140) { lastCheck = now; check(); }
    });
    function stop() { if (drawing) { drawing = false; check(); } }
    cv.addEventListener('pointerup', stop);
    cv.addEventListener('pointercancel', stop);
    $('[data-popup-skip]', root).addEventListener('click', reveal);

    window.addEventListener('resize', function () {
      if (root.isConnected && !root.hidden && !revealed && !touched) setup();
    });

    function open() {
      lastFocus = document.activeElement;
      var forced = (force === 'win' || force === 'lose') ? force
        : ((cfg.designMode && (conf.previewOutcome === 'win' || conf.previewOutcome === 'lose')) ? conf.previewOutcome : null);
      outcome = forced || (Math.random() * 100 < conf.chance ? 'win' : 'lose');
      revealed = false;
      touched = false;
      drawing = false;
      setHead(T.intro);
      fillPrize();
      cv.hidden = false;
      cv.style.opacity = '1';
      cv.style.pointerEvents = 'auto';
      hint.hidden = false;
      form.hidden = true;
      done.hidden = true;
      err.textContent = '';
      if (!force && !cfg.designMode) { try { window.localStorage.setItem('flair_popup_seen', String(Date.now())); } catch (e) {} }
      root.hidden = false;
      document.body.classList.add('no-scroll');
      root.scrollTop = 0;
      setup();
      closeBtn.focus();
    }
    function close() {
      root.hidden = true;
      document.body.classList.remove('no-scroll');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    $$('[data-popup-close]', root).forEach(function (b) { b.addEventListener('click', close); });
    root.addEventListener('pointerdown', function (e) { if (e.target === root) close(); });
    document.addEventListener('keydown', function (e) {
      if (!root.isConnected || root.hidden) return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      var f = $$('button, input, a[href]', root).filter(function (el) { return !el.hidden && el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], lastEl = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); lastEl.focus(); }
      else if (!e.shiftKey && document.activeElement === lastEl) { e.preventDefault(); first.focus(); }
    });

    function success() {
      var c = T[outcome];
      setHead({ eyebrow: c.doneEyebrow, title: c.doneTitle, text: c.doneText });
      form.hidden = true;
      done.hidden = false;
      if (!cfg.designMode) { try { window.localStorage.setItem('flair_popup_done', '1'); } catch (e) {} }
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email.value.trim())) {
        err.textContent = T.errorEmail;
        email.focus();
        return;
      }
      if (!consent.checked) {
        err.textContent = T.errorConsent;
        consent.focus();
        return;
      }
      err.textContent = '';
      tagsInput.value = conf.tags[outcome] || '';
      submitBtn.disabled = true;
      fetch(form.action, { method: 'POST', body: new FormData(form), headers: { 'Accept': 'text/html' } })
        .then(function (r) {
          if (!r.ok || String(r.url).indexOf('/challenge') !== -1) { form.submit(); return; }
          success();
        })
        .catch(function () { form.submit(); })
        .then(function () { submitBtn.disabled = false; });
    });

    window.__flairPopup = { open: open, close: close };
    if (autoOpen) setTimeout(open, cfg.designMode ? 300 : Math.max(0, conf.delay) * 1000);
  }

  /* ---------- Événements globaux ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    if (t.closest('[data-menu-toggle]')) { toggleMenu(); return; }
    var open = t.closest('[data-cart-open]');
    if (open && drawer() && cfg.template !== 'cart') { e.preventDefault(); openCart(); return; }
    if (t.closest('[data-cart-close]')) { closeCart(); return; }
    var q = t.closest('[data-qty-change]');
    if (q) { changeLine(parseInt(q.getAttribute('data-line'), 10), parseInt(q.getAttribute('data-qty'), 10)); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeCart();
      var m = $('[data-mobile-menu]');
      if (m && !m.hidden) toggleMenu();
    }
  });

  document.addEventListener('change', function (e) {
    var el = e.target;
    if (el.matches && el.matches('[data-auto-submit]') && el.form) el.form.submit();
  });

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches || !f.matches('[data-product-form]')) return;
    e.preventDefault();
    var btn = $('[data-add]', f);
    var msg = $('[data-form-msg]', f);
    btn.disabled = true;
    msg.textContent = '';
    fetch(cfg.routes.cart_add, { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(f) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) { msg.textContent = res.j.description || res.j.message || 'Impossible d\'ajouter ce produit.'; return null; }
        return refreshCart().then(openCart);
      })
      .catch(function () { f.submit(); })
      .then(function () { btn.disabled = false; });
  });

  function initAll() {
    setHeights();
    initHeader();
    initHero();
    initCountdown();
    initProduct();
    initPopup();
  }

  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:select', function (e) {
    if (e.detail && e.detail.sectionId === 'scratch-popup' && window.__flairPopup) window.__flairPopup.open();
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    if (e.detail && e.detail.sectionId === 'scratch-popup' && window.__flairPopup) window.__flairPopup.close();
  });
  window.addEventListener('resize', setHeights);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
})();
